export default function Section17() {
    const reasons = [
      {
        title: "Custom, SEO-Optimized Websites",
        text: "Every project is crafted to boost rankings and drive targeted traffic.",
      },
      {
        title: "Shopify & E-commerce Specialists",
        text: "From startup stores to enterprise-level solutions, we specialize in scalable e-commerce platforms.",
      },
      {
        title: "Agile, Scalable, & Future-Ready Builds",
        text: "Flexible, adaptable websites designed to grow with your business.",
      },
      {
        title: "Transparent Process & Dedicated Teams",
        text: "We keep you informed every step of the way, with clear communication and dedicated project managers.",
      },
      {
        title: "Proven Results Across Startups to Enterprises",
        text: "Measurable impact across multiple industries, from tech startups to large enterprises.",
      },
    ];
  
    return (
      <div className="Section17 py-[1px] md:py-[10px] bg-[white]">
        {/* Section Heading */}
        <div className="text-center w-[90%] md:w-[65%] mx-auto mb-[40px]">
          <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[36px] md:leading-[46px] mb-2">
            Why Choose <span className="text-[#DA2128]">Mean3</span> as Your Website Development Agency?
          </h2>
          <p className="text-[#555] text-[16px] md:text-[18px] font-medium mb-3">
            Why Leading Brands Trust Mean3 for Their Web Development Needs
          </p>
          <p className="text-[#777] text-[14px] md:text-[16px] mt-4">
            At Mean3, we combine technical expertise with creative solutions that deliver measurable results. Here’s why businesses choose us:
          </p>
        </div>
  
        {/* Cards Grid */}
        <div className="flex justify-center flex-wrap gap-[25px] w-[85%] mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`${index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
                } w-[90%] sm:w-[46%] xl:w-[30%] p-[4%] md:p-[2%] rounded-2xl shadow-md text-left`}
            >
              <h3 className="text-[20px] md:text-[22px] font-bold mb-3 leading-[28px]">
                {reason.title}
              </h3>
              <p className="text-[13px] md:text-[14px] mb-4">{reason.text}</p>
            </div>
          ))}
        </div>
  
        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="https://mean3.com/contact-mean3"  // replace with your target URL
            className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
          >
            Learn More About Us
          </a>
        </div>
  
        {/* Divider Line */}
        <div className="line mb-[55px] mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    );
  }
  